module.exports = __webpack_public_path__ + "static/media/10967384_880179012003522_247849312_o.21cf394c.jpg";